import {
  useMutation,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { pinLogin, regularUserLogin } from '../../services/auth.service';
import { IUser } from '../../interfaces/User';
import { IStore } from '../../interfaces/Store';
import { ICompany } from '../../interfaces/Company';
import { IIntercomSession } from '../../interfaces/Intercom';
const listQueryKey = 'auth';

export interface IPinLoginResponse {
  user: IUser & {
    isCompanyAdmin: boolean;
    hasMultiStore: boolean;
    role: string;
    stripeCustomerId: string;
  },
  intercom?: IIntercomSession,
  token: string,
  tokenValidity: number,
  storeInfo: IStore,
  company: {
    _id: string,
    companyServicesPermissions: any,
    companyTaxInfo?: ICompany['companyTaxInfo'],
    fiscalSettings?: ICompany['fiscalSettings'],
    planLevel: string,
    planStatus: string,
    stripeSubscriptionStartDate: any,
    stripeSubscriptionEndDate: any,
    logoUrl: string,
    name: string,
    country: ICompany['country']
  }
}

export interface IRegularUserLoginResponse {
  token: string;
  user: IUser;
  company: ICompany;
  intercom?: IIntercomSession;
}

export const usePinLogin = () => {
  return useMutation({
    mutationFn: async (data: {
      pinCode: string;
    }) => {
      try {
        const res = await pinLogin(data);
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while fetching.');
        }
        return res.data.data as IPinLoginResponse;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    }
  });
};

export const useRegularUserLogin = () => {
  return useMutation({
    mutationFn: async (data: {
      identifier: string;
      password: string;
    }) => {
      try {
        const res = await regularUserLogin(data);
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while fetching.');
        }
        return res.data.data as IRegularUserLoginResponse;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    }
  });
};
